import type { GridColDef } from '@mui/x-data-grid';
import { EmptyTableCell } from '@/components/EmptyTableCell';
import { formatAmount, formatPercentage } from '../../helpers';
import type { LeadSourcePerformanceRow } from '../hooks/useLeadSourcePerformance';
import { PercentageCellWithBackground } from './PercentageCellWithBackground';

export const LeadSourcePerformanceColumns: GridColDef<LeadSourcePerformanceRow>[] =
  [
    {
      field: 'leadSource',
      headerName: 'Lead Source',
      minWidth: 180,
      flex: 1,
    },
    {
      field: 'totalTransactions',
      headerName: 'Total Transactions',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'salesVolume',
      headerName: 'Sales Volume',
      valueFormatter: formatAmount,
      minWidth: 160,
      flex: 1,
    },
    {
      field: 'averageSaleValue',
      headerName: 'Avg Sale Value',
      valueFormatter: formatAmount,
      minWidth: 160,
      flex: 1,
    },
    {
      field: 'adjustedGci',
      headerName: 'Post-Referral GCI',
      valueFormatter: formatAmount,
      minWidth: 160,
      flex: 1,
    },
    {
      field: 'averageCommissionAmount',
      headerName: 'Average Commission',
      renderCell: ({ row }) =>
        row.averageCommissionAmount != null ? (
          formatAmount(row.averageCommissionAmount)
        ) : (
          <EmptyTableCell />
        ),
      valueFormatter: formatAmount,
      flex: 1,
      minWidth: 170,
    },
    {
      field: 'salesVolumePercent',
      headerName: '% of Total Sales Volume',
      minWidth: 220,
      flex: 1,
      valueFormatter: formatPercentage,
      renderCell: (params) => (
        <PercentageCellWithBackground
          total={params.row.totalSalesVolume}
          currentValue={params.row.salesVolume}
          backgroundColorFilled="primary.500"
          backgroundColorEmpty="primary.300"
        />
      ),
    },
  ];
export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
